import React, { useContext } from "react";
import { CenterContext } from "../../../../Context";

export default function StudentsAtLocation({ students }) {
    let locs = {}
  let total = 0
  const {getLocationName} = useContext(CenterContext)
    for (let student of students) {
        for (let htc of student.classes) {
            if (locs[htc.location]) {
                locs[htc.location]++
                total++
            } else {
                locs[htc.location] = 1
                total++
            }
        }
    }
    
      return (<div>{Object.keys(locs).map(l => <> {getLocationName(l)}  ({locs[l]}, {getPercent(total, locs[l])}%)</>)}{" "}</div>)

}

function getPercent(total, amount) {
    return Math.round((amount / total)*100)
}
